import React, {useEffect, useState,useRef} from "react";
import 'react-calendar/dist/Calendar.css';
import {Card, CardBody, CardHeader, CardTitle, Col, Row} from "reactstrap";
import IconButton from '@mui/material/IconButton';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import Tooltip from '@mui/joy/Tooltip';
import {TextField, Button, Typography, Grid, Box} from '@material-ui/core';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import axios from "axios";
import Cookies from "js-cookie";
import moment from "moment-jalali";
import JalaliMoment from "jalali-moment";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import EditNoteIcon from "@mui/icons-material/EditNote";


const cardStyle={
	backgroundColor:'#ebeff3',
	borderRadius:'25px',
	padding:'10px',
}

function ProfileEdit(props) {

	const [firstName, setFirstName] = useState();
	const [lastName, setLastName] = useState();
	const [sex, setSex] = useState();
	const [birthDate, setBirthDate] = useState();
	const [id, setId] = useState();

	const [address, setAddress] = useState();
	const [phone, setPhone] = useState();
	const [email, setEmail] = useState();

	const [image, setImage] = useState([]);
	const fileInputRefImage = useRef(null);

	const englishToPersianNumbers = (input) => {
		if (typeof input !== 'string' && !(input instanceof Date)) {
			console.error('Input must be a string or a Date object');
			return input;
		}

		// Define a mapping of English digits to Persian digits
		const digitMap = {
			'0': '۰',
			'1': '۱',
			'2': '۲',
			'3': '۳',
			'4': '۴',
			'5': '۵',
			'6': '۶',
			'7': '۷',
			'8': '۸',
			'9': '۹',
		};

		// Convert numbers in the input to Persian numbers
		const convertedString = input.toString().replace(/\d/g, (digit) => digitMap[digit] || digit);

		return convertedString;
	};
	const convertToSolarAndPersian = (gregorianDate) => {
		// Convert Gregorian date to Jalali (Solar) date
		if (!gregorianDate) gregorianDate = '2111-11-11'
		const solarDate = moment(gregorianDate, 'YYYY-MM-DD').format('jYYYY/jMM/jDD');

		// Convert English numbers to Persian numbers
		const persianNumbers = englishToPersianNumbers(solarDate)
		//const persianNumbers = Persian(solarDate.toString()).englishNumber().persianNumber()._str;

		return persianNumbers;
	};

	const JalaliMoment = require('jalali-moment');
	const persianToEnglishNumbers = (input) => {
		if (typeof input !== 'string' && !(input instanceof Date)) {
			console.error('Input must be a string or a Date object');
			return input;
		}

		// Define a mapping of Persian digits to English digits
		const digitMap = {
			'۰': '0',
			'۱': '1',
			'۲': '2',
			'۳': '3',
			'۴': '4',
			'۵': '5',
			'۶': '6',
			'۷': '7',
			'۸': '8',
			'۹': '9',
		};

		// Convert Persian numbers in the input to English numbers
		const convertedString = input.toString().replace(/[۰-۹]/g, (digit) => digitMap[digit] || digit);

		return convertedString;
	};
	const convertToGregorianAndEnglish = (persianDate) => {
		// Convert Persian (Solar) date to Gregorian date
		if (!persianDate) persianDate = '۱۳۹۹/۰۱/۰۱'; // Replace with your Persian date
		const englishNumbers = persianToEnglishNumbers(persianDate);
		const gregorianDate = JalaliMoment(englishNumbers, 'jYYYY/jMM/jDD').format('YYYY-MM-DD');

		// Convert Persian numbers to English numbers
		//const englishNumbers = persianToEnglishNumbers(gregorianDate);

		return gregorianDate;
	};

	const [fileHanlde, setFileHanlde] = useState(0); // if 0 > no file if 1 > image

	//api request for info
	useEffect(() => {
		axios.get('https://back.actelmon.ir/api/doctor/profile/', {
			headers: {
				Authorization: `${Cookies.get('token')}` // Assuming you have a function to get the cookie value
			}
		})
			.then((response) => {
				setFirstName(response.data.name)
				setLastName(response.data.last_name)
				setSex(response.data.gender)
				response.data.birth_date ? setBirthDate(convertToSolarAndPersian(response.data.birth_date)) : setBirthDate(convertToSolarAndPersian('2111-11-11'))

				response.data.id ? setId(englishToPersianNumbers(response.data.id.toString())) : setId(englishToPersianNumbers('0'))
				setAddress(response.data.address)
				response.data.username ? setPhone(englishToPersianNumbers(response.data.username)) : setPhone(englishToPersianNumbers('090'))
				setEmail(response.data.email)
			})
			.catch((error) => {
				console.error('Error fetching profileedit data:', error);
			});

	}, []);

	const handleImageInput = (e) => {
		const selectedFiles = Array.from(e.target.files);
		setImage(selectedFiles[0]);
		setFileHanlde( fileHanlde === 0 ? 1 : 3 );
	};

	const handleDropImage = (e) => {
		e.preventDefault();
		const droppedFiles = Array.from(e.dataTransfer.files);
		setImage(droppedFiles[0]);
		setFileHanlde( fileHanlde === 0 ? 1 : 3 );
	};

	const handleDragOverImage = (e) => {
		e.preventDefault();
	};

	//post data
	const handleConfirm = () => {
		const formData = new FormData();
		if(fileHanlde === 1){
			formData.append("name", firstName);
			formData.append("last_name", lastName);
			formData.append("email", email);
			formData.append("gender", sex);
			formData.append("birth_date", convertToGregorianAndEnglish(birthDate));
			formData.append("address", address);
			formData.append("photo", image);
		}else if(fileHanlde === 0){
			formData.append("name", firstName);
			formData.append("last_name", lastName);
			formData.append("email", email);
			formData.append("gender", sex);
			formData.append("birth_date", convertToGregorianAndEnglish(birthDate));
			formData.append("address", address);
		}

		// Send the post request
		axios.post(`https://back.actelmon.ir/api/doctor/profile/`, formData, {
			headers: {
				Authorization: `${Cookies.get('token')}`,
				'Content-Type': 'multipart/form-data', // Specify the content type
			},
		})
			.then((response) => {
				console.log('Data posted successfully Profile Edit:', response.data);
				console.log('mydata',formData)
				// Handle success if needed
			})
			.catch((error) => {
				console.log('Data Profile Edit post', error)
			});

		props.edit(false)
	};

	const toPersianNumber = (text) => {
		const persianNumbers = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
		return text.replace(/\d/g, (digit) => persianNumbers[digit]);
	};

	return (
		<>
			<div className="content">
				<Col lg="12" sm="12" style={{backgroundColor:'white',padding:'30px',borderRadius:'10px'}}>

					<Row lg="6" sm="6">

						<Col lg="5" sm="5">
							<Card style={cardStyle} >
								<CardHeader className="text-right">
									<CardTitle tag="h4" style={{color:'#EBAB60',fontWeight:'bold'}}>اطلاعات شخصی</CardTitle>
								</CardHeader>

								<CardBody>
									{/*first name*/}
									<Grid container spacing={2} style={{direction:'rtl', textAlign:'right'}} alignItems="center">
										<Grid item xs={5} >
											<Typography gutterBottom style={{color:'#757575'}}>
												نام
											</Typography>
										</Grid>
										<Grid item xs={7}>
											<TextField id="outlined-basic"
											           variant="outlined"
											           value={firstName}
											           onChange={(event) => {setFirstName(event.target.value)}} />
										</Grid>
									</Grid>
									{/*last name*/}
									<Grid container spacing={2} style={{direction:'rtl', textAlign:'right'}} alignItems="center">
										<Grid item xs={5}>
											<Typography gutterBottom style={{color:'#757575'}}>
												نام خانوادگی
											</Typography>
										</Grid>
										<Grid item xs={7}>
											<Typography gutterBottom>
												<TextField id="outlined-basic"
												           variant="outlined"
												           value={lastName}
												           onChange={(event) => {setLastName(event.target.value)}} />
											</Typography>
										</Grid>
									</Grid>
									{/*sex*/}
									<Grid container spacing={2} style={{direction:'rtl', textAlign:'right'}} alignItems="center">
										<Grid item xs={5}>
											<Typography gutterBottom style={{color:'#757575'}}>
												جنسیت
											</Typography>
										</Grid>
										<Grid item xs={7}>
											<FormControl style={{width:'100%'}}>
												<Select
													labelId="demo-simple-select-label"
													value={sex === 'm' ? 0 : 1}
													onChange={
														(event) => {
															event.target.value === 0 ? setSex('m') : setSex('f')
														}
													}
													style={{height:'55px',textAlign:'right',direction:'rtl'}}
												>
													<MenuItem value={0}>مرد</MenuItem>
													<MenuItem value={1}>زن</MenuItem>

												</Select>
											</FormControl>
										</Grid>
									</Grid>
									{/*id*/}
									<Grid container spacing={2} style={{direction:'rtl', textAlign:'right'}} alignItems="center">
										<Grid item xs={5}>
											<Typography gutterBottom style={{color:'#757575'}}>
												کد شناسایی
											</Typography>
										</Grid>
										<Grid item xs={7}>
											<Typography gutterBottom>
												<TextField id="outlined-basic"
												           variant="outlined"
												           value={id}
												           onChange={(event) => {setId(englishToPersianNumbers(event.target.value))}} />
											</Typography>
										</Grid>
									</Grid>
									{/*birth date*/}
									<Grid container spacing={2} style={{direction:'rtl', textAlign:'right'}} alignItems="center">
										<Grid item xs={5}>
											<Typography gutterBottom style={{color:'#757575'}}>
												تاریخ تولد
											</Typography>
										</Grid>
										<Grid item xs={7}>
											<Typography gutterBottom>
												<TextField id="outlined-basic"
												           variant="outlined"
												           value={birthDate}
												           onChange={(event) => {setBirthDate(englishToPersianNumbers(event.target.value))}} />
											</Typography>
										</Grid>
									</Grid>
								</CardBody>
							</Card>
						</Col>

						<Col lg="4" sm="4">
							<Card style={{...cardStyle}} >
								<CardHeader className="text-center">
									<CardTitle tag="h4" style={{color:'#EBAB60',fontWeight:'bold'}}>عکس پروفایل</CardTitle>
								</CardHeader>

								<CardBody>
									<Grid container alignItems="center" justifyContent="center">
										<Grid item>
											<div
												onDrop={handleDropImage}
												onDragOver={handleDragOverImage}
												onClick={() => fileInputRefImage.current.click()} // Trigger file input
												style={{
													border: '2px dashed #ccc',
													borderRadius: '5px',
													padding: '20px',
													textAlign: 'center',
													backgroundColor: 'white',
													cursor: 'pointer',
												}}
											>
												<input
													type="file"
													accept="image/*" // Define accepted file types
													style={{ display: 'none' }}
													ref={fileInputRefImage} // Create a reference to the file input
													onChange={handleImageInput}
												/>
												<CloudUploadOutlinedIcon
													sx={{ color: "#6e6e6e", fontSize:'50px'}}
												/>
												<br/>
												<Typography variant="caption">فایل را در اینجا بکشید و رها کنید و یا کلیک کنید. نوع فایل یکی از انواع png, jpeg, jpg و حجم فایل ارسالی حداکثر 800 کیلوبایت باشد.</Typography>
												<Box>
													<Typography>{image.name}</Typography>
												</Box>
											</div>
										</Grid>
									</Grid>
								</CardBody>
							</Card>
						</Col>

						{/* <Col lg="3" sm="3">

							<Grid container>
								<Grid item xs={12} container justifyContent="center" alignItems="center">
									<Grid container spacing={1} justifyContent="center" alignItems="center">
										<Grid item lg="6" sm="6">
											<Button variant="contained"
											        fullWidth
											        style={{backgroundColor:'#138C97',color:'white'}}
											        startIcon={<CheckCircleOutlineIcon sx={{marginLeft:'10px', color:'white'}} />}
											        onClick={handleConfirm}
											>
												ثبت
											</Button>
										</Grid>
										<Grid item item lg="6" sm="6">
											<Button variant="contained"
											        fullWidth
											        style={{backgroundColor:'#DD8E9C',color:'white'}}
											        startIcon={<KeyboardReturnIcon sx={{marginLeft:'10px', color:'white'}} />}
											        onClick={() => props.edit(false)}
											>
												بازگشت
											</Button>
										</Grid>
									</Grid>
								</Grid>
							</Grid>

						</Col> */}

					</Row>

					<Row lg="6" sm="6">

						<Col lg="5" sm="5">
							<Card style={cardStyle} >
								<CardHeader className="text-right">
									<CardTitle tag="h4" style={{color:'#EBAB60',fontWeight:'bold'}}>اطلاعات تماس</CardTitle>
								</CardHeader>

								<CardBody>
									{/*address*/}
									<Grid container spacing={2} style={{direction:'rtl', textAlign:'right'}} alignItems="center">
										<Grid item xs={3}>
											<Typography gutterBottom style={{color:'#757575'}}>
												آدرس
											</Typography>
										</Grid>
										<Grid item xs={9}>
											<Typography gutterBottom>
												<TextField id="outlined-basic"
												           fullWidth
												           variant="outlined"
												           value={address}
												           onChange={(event) => {setAddress(toPersianNumber(event.target.value))}} />
											</Typography>
										</Grid>
									</Grid>
									{/*phone*/}
									<Grid container spacing={2} style={{direction:'rtl', textAlign:'right'}} alignItems="center">
										<Grid item xs={3}>
											<Typography gutterBottom style={{color:'#757575'}}>
												تلفن
											</Typography>
										</Grid>
										<Grid item xs={9}>
											<Typography gutterBottom>
												<TextField id="outlined-basic"
												           fullWidth
												           variant="outlined"
												           value={phone}
												           onChange={(event) => {setPhone(englishToPersianNumbers(event.target.value))}} />
											</Typography>
										</Grid>
									</Grid>
									{/*email*/}
									<Grid container spacing={2} style={{direction:'rtl', textAlign:'right'}} alignItems="center">
										<Grid item xs={3}>
											<Typography gutterBottom style={{color:'#757575'}}>
												ایمیل
											</Typography>
										</Grid>
										<Grid item xs={9}>
											<Typography gutterBottom>
												<TextField id="outlined-basic"
												           fullWidth
												           variant="outlined"
												           value={email}
												           onChange={(event) => {setEmail(event.target.value)}} />
											</Typography>
										</Grid>
									</Grid>
								</CardBody>
							</Card>
						</Col>
					</Row>
					<Row>
{/* dummy stuff dont open it AMS */}
  <Col lg="3" sm="3">
    <Grid container justifyContent="flex-start"> {/* Changed justifyContent to flex-start */}
      <Grid item xs={12} container justifyContent="center" alignItems="center">
        <Grid container spacing={1} justifyContent="center" alignItems="center">
          <Grid item lg={6} sm={6}> {/* Changed lg="6" and sm="6" to lg={6} and sm={6} */}

          </Grid>
          <Grid item lg={6} sm={6}> {/* Changed lg="6" and sm="6" to lg={6} and sm={6} */}

          </Grid>
        </Grid>
      </Grid>
    </Grid>
  </Col>

  <Col lg="3" sm="3">
    <Grid container justifyContent="flex-start"> {/* Changed justifyContent to flex-start */}
      <Grid item xs={12} container justifyContent="center" alignItems="center">
        <Grid container spacing={1} justifyContent="center" alignItems="center">
          <Grid item lg={6} sm={6}> {/* Changed lg="6" and sm="6" to lg={6} and sm={6} */}

          </Grid>
          <Grid item lg={6} sm={6}> {/* Changed lg="6" and sm="6" to lg={6} and sm={6} */}

          </Grid>
        </Grid>
      </Grid>
    </Grid>
  </Col>

  <Col lg="3" sm="3">
    <Grid container justifyContent="flex-start"> {/* Changed justifyContent to flex-start */}
      <Grid item xs={12} container justifyContent="center" alignItems="center">
        <Grid container spacing={1} justifyContent="center" alignItems="center">
          <Grid item lg={6} sm={6}> {/* Changed lg="6" and sm="6" to lg={6} and sm={6} */}

          </Grid>
          <Grid item lg={6} sm={6}> {/* Changed lg="6" and sm="6" to lg={6} and sm={6} */}

          </Grid>
        </Grid>
      </Grid>
    </Grid>
  </Col>
{/*The end dummy stuff dont open it AMS */}

  <Col lg="3" sm="3">
    <Grid container justifyContent="flex-start"> {/* Changed justifyContent to flex-start */}
      <Grid item xs={12} container justifyContent="center" alignItems="center">
        <Grid container spacing={1} justifyContent="center" alignItems="center">
          <Grid item lg={6} sm={6}> {/* Changed lg="6" and sm="6" to lg={6} and sm={6} */}
            <Button variant="contained"
                    fullWidth
                    style={{backgroundColor:'#138C97',color:'white'}}
                    startIcon={<CheckCircleOutlineIcon sx={{marginLeft:'10px', color:'white'}} />}
                    onClick={handleConfirm}
            >
              ثبت
            </Button>
          </Grid>
          <Grid item lg={6} sm={6}> {/* Changed lg="6" and sm="6" to lg={6} and sm={6} */}
            <Button variant="contained"
                    fullWidth
                    style={{backgroundColor:'#DD8E9C',color:'white'}}
                    startIcon={<KeyboardReturnIcon sx={{marginLeft:'10px', color:'white'}} />}
                    onClick={() => props.edit(false)}
            >
              بازگشت
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  </Col>
</Row>

				</Col>
			</div>
		</>
	);
}

export default ProfileEdit;
